import React from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import CustomDate from '../../../CustomDate'

import { LOCALE_PREFIX } from '../../constants'

export default function EntityInformation({ data }) {
    return (
        <>
            <div className={'row title'}>
                <div className={cx('icon', `entity-${data?.type}${data?.inactive ? 'Inactive' : ''}`)} />
                <span>{data?.name ?? ''}</span>
            </div>
            <div className={'block-separator big'} />
            {data?.regNbr && (
                <div className={'row'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.regNbr`} values={{ regNbr: data?.regNbr }} />
                </div>
            )}
            {(data?.startDate || data?.endDate) && (
                <div className={'row'}>
                    {data?.startDate && (
                        <CustomDate date={data?.startDate?.value} precision={data?.startDate?.precision} />
                    )}
                    {data?.startDate && data?.endDate && <span style={{ padding: '0 4px' }}>{'-'}</span>}
                    {data?.endDate && <CustomDate date={data?.endDate?.value} precision={data?.endDate?.precision} />}
                </div>
            )}
            <div className={'block-separator'} />
            {data?.street && (
                <div className={'row'}>
                    <span>{data?.street}</span>
                </div>
            )}
            {data?.town && (
                <div className={'row'}>
                    <span>{data?.town}</span>
                </div>
            )}
            {data?.country && (
                <div className={'row'}>
                    <span>{data?.country}</span>
                </div>
            )}
            <div className={'block-separator'} />
        </>
    )
}
